'use client';

import { createContext, useContext } from 'react';

const DataContext = createContext([]);

export function CategoriesDataProvider({ children, initialData }: any) {
  return (
    <DataContext.Provider value={initialData}>{children}</DataContext.Provider>
  );
}

export function useCategoriesData(): any[] {
  return useContext(DataContext);
}
